export default "__VITE_ASSET__b4357a28__"